import Config from '../config'

const TOKEN_PATTERN = /^ahacf-[0-9a-f]{32}$/
const SAFE_URL_PATTERN = /^https:\/\/[^\s"'()<>\\]+$/
const CSS_FORMAT_BY_FONT_FORMAT = {
  ttf: 'truetype',
  otf: 'opentype',
  woff: 'woff',
  woff2: 'woff2',
}
const pendingByToken = new Map()

export const isCustomFontToken = (font) => typeof font === 'string' && TOKEN_PATTERN.test(font)

export const customFontStack = (token) => `"${token}", "Plus Jakarta Sans", Cairo, sans-serif`

const injectFontFace = (token, { url, format }) => {
  const cssFormat = CSS_FORMAT_BY_FONT_FORMAT[format]
  if (!cssFormat || typeof url !== 'string' || !SAFE_URL_PATTERN.test(url)) {
    return
  }
  const style = document.createElement('style')
  style.setAttribute('data-aha-custom-font', token)
  style.textContent = `@font-face {
  font-family: "${token}";
  src: url("${url}") format("${cssFormat}");
  font-display: swap;
}`
  document.head.appendChild(style)
}

const alreadyInjected = (token) => document.head.querySelector(`style[data-aha-custom-font="${token}"]`)

const REQUEST_TIMEOUT_MS = 8000

const loadFont = async (token) => {
  const controller = typeof AbortController === 'function' ? new AbortController() : null
  const timer = controller ? setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS) : null
  try {
    const response = await fetch(`${Config.baseUrl}/api/custom-fonts/public/${token}`, {
      credentials: 'omit',
      ...(controller ? { signal: controller.signal } : {}),
    })
    const font = response && response.ok ? await response.json() : null
    if (font && typeof font === 'object') {
      injectFontFace(token, font)
    }
  } catch (error) {
    // a failing custom font must never block the page; the fallback stack stays in effect
  } finally {
    if (timer) {
      clearTimeout(timer)
    }
  }
}

export const applyCustomFont = (token) => {
  try {
    if (!isCustomFontToken(token)) {
      return Promise.resolve()
    }
    if (alreadyInjected(token) || pendingByToken.has(token)) {
      return pendingByToken.get(token) || Promise.resolve()
    }
    const pending = loadFont(token).finally(() => pendingByToken.delete(token))
    pendingByToken.set(token, pending)
    return pending
  } catch (error) {
    pendingByToken.delete(token)
    return Promise.resolve()
  }
}
